module.exports = __webpack_public_path__ + "media/images/lp_consultation/professional04-4aca7f558b873a33f3ec3228a1f4b650.jpg";